export default __webpack_public_path__ + "static/media/logo_brand_mobile.1da424d8.svg";